// import React from "react";

// const HeroSection = () => {
//   return (
//     <div className="flex flex-col gap-[25px] sm:gap-[37px] lg:gap-[50px] justify-start items-center w-full mt-[80px] 2xl:mt-[132px] mb-[50px]">
//       <div className="flex flex-col gap-[25px] sm:gap-[37px] lg:gap-[50px] justify-start items-center w-full max-w-[806px] sm:max-w-[1209px] lg:max-w-[1612px]">
//         {/* Text Content */}
//         <div className="flex flex-col gap-[10px] sm:gap-[15px] lg:gap-[20px] justify-start items-center w-full">
//           <h1 className="text-[30px] sm:text-[45px] lg:text-[60px] font-bold leading-[37px] sm:leading-[56px] lg:leading-[75px] text-center font-[Sora] w-auto">
//             Enhancing Soil Health
//             <br />
//             for Sustainable Agriculture
//           </h1>
//           <p className="text-[12px] sm:text-[18px] lg:text-[24px] font-normal leading-[19px] sm:leading-[28px] lg:leading-[38px] text-center w-full font-[Sora]">
//             At Govardhannathji Energies LLP, we are dedicated to providing
//             high-quality organic fertilizers that nurture the soil and promote
//             sustainable farming practices. Our fertilizers are carefully
//             formulated using natural ingredients to ensure optimal plant growth
//             while preserving soil fertility for future generations.
//           </p>
//         </div>

//         {/* Hero Image/Video Placeholder */}
//         <div className="w-full bg-background-neutral rounded-[15px] sm:rounded-[22px] lg:rounded-[30px] h-[343px] sm:h-[514px] lg:h-[686px]">
//           <img
//             src="/images/aboutImg/AboutHome.png"
//             alt="Bio gas facility"
//             className="w-full rounded-[15px] sm:rounded-[22px] h-full hero-image object-cover "
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default HeroSection;
import React from "react";
import CommonHeroSection from "../../component/common/CommonHeroSection";

const HeroSection = () => {
  return (
    <CommonHeroSection
      title={
        <>
          Enhancing Soil Health
          <br />
          for Sustainable Agriculture
        </>
      }
      description="At Govardhannathji Energies LLP, we are dedicated to providing high-quality organic fertilizers that nurture the soil and promote sustainable farming practices. Our fertilizers are carefully formulated using natural ingredients to ensure optimal plant growth while preserving soil fertility for future generations."
      imageSrc="/images/productHEro.png"
      imageAlt="Bio gas facility"
      // subtitle="Our Mission" // Optional: Uncomment if you want to test the divider line animation
    />
  );
};

export default HeroSection;
